// extracted by mini-css-extract-plugin
module.exports = {"jumio":"JumioVerification_jumio__6gcU1","loader":"JumioVerification_loader__19AcM"};